import React from 'react'

import "./newsbar.css"
import { articleinfo, Article } from "./articles"

export default function Newsbar() {

    const articles = articleinfo.map(article => {
        return (
          <Article 
            key={article.id}
            {...article}
          />
        )
    })        
  return (
    <div className='emas__newsbar'>
        <div className='emas__newsbar-heading'>
            <h1>Market Commentary</h1>
        </div>
        <section className='emas__newsbar-articles'>
            {articles}
        </section>
    </div>
  )
}
